import React, { useContext } from "react";
import Chart from "./HomeComponents/Chart/Chart";
import Counters from "./HomeComponents/Counters/Counters";
import Notifications from "./HomeComponents/Notifications/Notifications";
import ManegarsTable from "./HomeComponents/ManegarsTable/ManegarsTable";
import { AuthContext } from "../../../context/AuthContext";
import { ROLES } from "../../../constants/roles";

export default function Home() {
  const { role } = useContext(AuthContext);
  return (
    <>
      <div className="main">
        <Counters />

        <div className="row align-items-center justify-content-center">
          <div className=" col-xxl-8 col-xl-8 col-lg-12 col-md-12 ">
            <Chart />
          </div>
          <div className=" col-xxl-4 col-xl-12 col-lg-4 col-md-12 mt-3">
            <Notifications />
          </div>
        </div>

        {/* {role === ROLES.OWNER && <ManegarsTable />} */}
      </div>
    </>
  );
}
